import { render } from "./PointsEarnManagement.html?vue&type=template&id=224ec0e1&scoped=true"
import script from "./PointsEarnManagement.js?vue&type=script&lang=js"
export * from "./PointsEarnManagement.js?vue&type=script&lang=js"

import "./PointsEarnManagement.css?vue&type=style&index=0&id=224ec0e1&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224ec0e1"]])

export default __exports__